'use strict';

import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import ClickAwayListener from 'react-click-away-listener';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames/bind';

import { getHistory } from '@/history';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';

import Link from '@/views/common/Link';

import s from './styles.scss';

const sx = cn.bind(s);

export default connect(
	(state, props) => ({
		isMenuOpen: appSelectors.isMenuOpen(state, props),
		user: usersSelectors.getLoggedInUser(state, props),
	}),
	{
		setMenuClose: appOperations.setMenuClose,
		setModalOpen: appOperations.setModalOpen,
	}
)(
	({ user, isMenuOpen, setMenuClose, setModalOpen }) => {

		if (!user) {
			return <div />;
		}

		const [ state, setState ] = useState(0);
		const history = getHistory();

		useEffect(
			() => {
				if (isMenuOpen) {
					setState(1);
				}
			},
			[ isMenuOpen ]
		)

		const onClick = useCallback(
			url => () => {
				history.push(url);
				setMenuClose();
			},
			[ user ]
		);

		return (
			<div className={ sx('menu', { visible: isMenuOpen, invisible: !isMenuOpen }) }>
				<ClickAwayListener onClickAway={
					() => {
						if (state === 1) {
							setMenuClose();
							setState(0);
						}
					}
				}>
					<div>
						<span
							className={ s.closeMenu }
							onClick={ setMenuClose }
						>
							<FontAwesomeIcon icon='times' color='#777'/>
						</span>
						<ul className={ s.menuList }>
							<li
								onClick={ onClick(`/user/${ user.username }`) }
								className={ s.item }
							>
								<FontAwesomeIcon icon='user' color='#444'/>
								<label>{ user.username }</label>
							</li>
							<li
								onClick={ onClick(`/user/${ user.username }/settings`) }
								className={ s.item }
							>
								<FontAwesomeIcon icon='sliders-h' color='#444'/>
								<label>Settings</label>
							</li>
							<li
								onClick={
									() => {
										setModalOpen('createUser');
										setMenuClose();
									}
								}
								className={ s.item }
							>
								<FontAwesomeIcon icon='user-plus' color='#444'/>
								<label>Create User</label>
							</li>
							<li className={ s.item }>
								<a
									className={ s.link }
									onClick={
										e => {
											e.preventDefault();
											localStorage.removeItem('user');
											window.location.replace('/logout');
										}
									}
								>
									<FontAwesomeIcon icon='sign-out-alt' color='#444'/>
									<label>Log off</label>
								</a>
							</li>
						</ul>
					</div>
				</ClickAwayListener>
			</div>
		);
	}
);
